import { createAction, props } from '@ngrx/store';

export const loadSupervisors = createAction('[Supervisor Lookup] Load');

export const loadSupervisorsSuccess = createAction(
  '[Supervisor Lookup] Load Success',
  props<{ supervisors: Array<{ id: number; name: string }> }>()
);

export const loadSupervisorsFailure = createAction(
  '[Supervisor Lookup] Load Failure',
  props<{ error: string }>()
);
